import React, { useRef, useState } from "react";
import { FiRewind, FiFastForward } from "react-icons/fi";
import api from "../../utils/api";

const VideoPlayer = ({
  src,
  userId,
  videoId,
  videoUserId,
  videoChannelId,
}) => {
  const videoRef = useRef(null);
  const [showSeek, setShowSeek] = useState(false);
  const viewSentRef = useRef(false);

  const sendView = async () => {
    if (!userId || !videoId || !videoUserId || !videoChannelId) return;
    if (viewSentRef.current) return;

    viewSentRef.current = true;

    try {
      await api.post("/client/watchHistory/createWatchHistory", null, {
        params: {
          userId,
          videoId,
          videoUserId,
          videoChannelId,
          currentWatchTime: 1,
        },
      });
    } catch (err) {
      console.error(
        "View increment failed:",
        err?.response?.data || err.message
      );
    }
  };

  const seek = (seconds) => {
    const video = videoRef.current;
    if (!video) return;

    video.currentTime = Math.min(
      Math.max(video.currentTime + seconds, 0),
      video.duration || Infinity
    );

    video.play().catch(() => {});
  };

  return (
    <div
      style={{ position: "relative", width: "100%", height: "100%" }}
      onMouseMove={() => setShowSeek(true)}
      onMouseLeave={() => setShowSeek(false)}
    >
      <video
        ref={videoRef}
        src={src}
        controls
        autoPlay
        playsInline
        onPlay={sendView}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          background: "#000",
          borderRadius: 8,
        }}
      />

      {showSeek && (
        <div
          style={{
            position: "absolute",
            bottom: 60,
            right: 20,
            display: "flex",
            gap: 10,
            zIndex: 5,
          }}
        >
          <button onClick={() => seek(-10)} style={btnStyle}>
            <FiRewind /> 10s
          </button>

          <button onClick={() => seek(15)} style={btnStyle}>
            15s <FiFastForward />
          </button>
        </div>
      )}
    </div>
  );
};

const btnStyle = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "6px 10px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  background: "rgba(0,0,0,0.75)",
  color: "#fff",
  fontSize: 13,
};

export default VideoPlayer;
